import { render } from "./Rvo.vue?vue&type=template&id=481033d1&scoped=true"
import script from "./Rvo.vue?vue&type=script&lang=js"
export * from "./Rvo.vue?vue&type=script&lang=js"

import "./Rvo.vue?vue&type=style&index=0&id=481033d1&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481033d1"]])

export default __exports__